import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { ButtonComponent } from '../../../../kit/button/button.component';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { TableColumn } from '../../../../../modules/shared/components/kit/table/table.types';
import { toSignal } from '@angular/core/rxjs-interop';
import { FolderEPrescriptionSearchMedicationModalStore } from './folder-e-prescription-search-medications-modal.store';
import { RadioInputComponent } from '../../../../kit/input/radio-input/radio-input.component';
import { MultiSelectInputComponent } from '../../../../kit/input/multi-select-input/multi-select-input.component';
import { SelectButtonInputComponent } from '../../../../kit/input/select-button-input/select-button-input.component';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import {
    InsuranceCompanySelectInputComponent,
} from '../../../element/insurance-company-select-input/insurance-company-select-input.component';

@Component({
    selector: 'app-folder-e-prescription-medication-entries-modal',
    templateUrl: 'folder-e-prescription-search-medications-modal.component.html',
    styleUrls: ['folder-e-prescription-search-medications-modal.component.scss'],
    providers: [FolderEPrescriptionSearchMedicationModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonsComponent,
        ButtonComponent,
        RadioInputComponent,
        InsuranceCompanySelectInputComponent,
        MultiSelectInputComponent,
        SelectButtonInputComponent,
        TableComponent,
    ],
})
export class FolderEPrescriptionSearchMedicationsModalComponent extends BaseDialogComponent {
    protected readonly store = inject(FolderEPrescriptionSearchMedicationModalStore);

    protected types = [
        { key: 'all', value: 'all' },
        { key: 'ambu', value: 'ambu' },
        { key: 'cumulatives', value: 'cumulatives' },
        { key: 'restricted', value: 'restricted' },
    ];

    protected sortTypes = [
        { value: 'alphabetically', name: 'alphabetically' },
        { value: 'code', name: 'code' },
        { value: 'NG3Group', name: 'NG3Group' },
        { value: 'substances', name: 'substances' },
        { value: 'selected', name: 'selected' },
        { value: 'canceled', name: 'canceled' },
        { value: 'SUKL', name: 'SUKL' },
        { value: 'price', name: 'price' },
    ];

    protected form = fb.group({
        type: fb.control<string>('all'),
        atcGroup: fb.control<string[] | null>(null),

        sort: fb.control<string>('alphabetically'),
        insuranceAbbr: fb.control<string | null>(null),
    });

    protected columns: TableColumn[] = [
        {
            name: 'availability',
        },
        {
            name: 'code',
        },
        {
            name: 'name',
        },
        {
            name: 'nameAddition',
        },
        {
            name: 'ctc',
        },
        {
            name: 'm',
        },
        {
            name: 'vyr',
        },
        {
            name: 'k',
        },
        {
            name: 'payment',
        },
        {
            name: 'price',
        },
        {
            name: 'addPayment',
        },
        {
            name: 'l',
        },
        {
            name: 'restriction',
        },
        {
            name: 'zapDopl',
        },
        {
            name: 'zvysUhr',
        },
        {
            name: 'info',
        },
    ];

    protected selectedMedication = signal<any>(null);

    private filterChanged = toSignal(this.form.valueChanges);

    constructor() {
        super();

        effect(() => {
            const filter = this.filterChanged();

            this.store.api.getMedications({}).then();
        });
    }

    selection(event: Event) {
        this.selectedMedication.set(event);
    }

    select(event: Event) {

    }

    interaction() {

    }
}
